import { addTags } from './addTags';
export function configureScope(sentryInstance, options) {
    const { user, appName, tags } = options;
    sentryInstance.configureScope((scope) => {
        if (user) {
            scope.setUser(user);
        }
        if (tags) {
            addTags(scope, appName, tags);
        }
    });
}
//# sourceMappingURL=configureScope.js.map